import { styled } from '@mui/material/styles';

import ActionButton from '@/components/ActionButton/index.ts';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(5),
  paddingTop: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(5),
  },
}));

const Title = styled('p')(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  fontSize: '25px',
  width: '80%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '22px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '19px',
    width: '100%',
  },
}));

const Subtitle = styled('p')(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '22px',
  width: '79%',
  lineHeight: '36px',
  color: '#354661',
  [theme.breakpoints.down('md')]: {
    fontSize: '19px',
    width: '70%',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    width: '100%',
    lineHeight: '30px',
  },
}));

const StyledActionButton = styled(ActionButton)(({ theme }) => ({
  minWidth: 300,
  maxWidth: 300,
  maxHeight: 60,
  fontSize: '19px',
  width: '100%',
  backgroundColor: '#FA8331',
  borderColor: '#FA8331',
  color: '#fff',
  '&:hover': {
    borderColor: '#FA8331',
    color: '#FA8331',
  },
  [theme.breakpoints.up(395)]: {
    minWidth: 400,
  },
  [theme.breakpoints.up('sm')]: {
    minWidth: 400,
    maxHeight: 70,
  },
  [theme.breakpoints.up('md')]: {
    minWidth: 400,
  },
}));

const Description3Component = () => {
  return (
    <BoxContainer>
      <Title className="typography-v1-body1">Bli med på gjeldvett!</Title>
      <Subtitle className="typography-v1-body1">
        Ikke lån mere, fiks heller opp i den gjelden du allerede har.
      </Subtitle>
      <StyledActionButton
        label="Delta og sjekk min gjeld"
        step="init"
        flow="march_2024_campaign"
        color="secondary"
        gaEvent="march_competition_cta_clicked"
        labelClassName="action-button-text"
        sx={{
          '& .action-button-text': {
            width: '100%',
            fontSize: {
              xs: '19px',
              md: '22px',
            },
          },
        }}
      />
    </BoxContainer>
  );
};

export default Description3Component;
